import React from 'react'

export default function Notfound() {
    return (
        <div>
            <h1>404 Page not found</h1>
        </div>
    )
}
